export function ScaleInput({
  id,
  label,
  hint,
  value,
  onChange,
  min = 1,
  max = 10,
  step = 1,
  optional = false,
}: {
  id: string;
  label: string;
  hint?: string;
  value: number | null;
  onChange: (n: number) => void;
  min?: number;
  max?: number;
  step?: number;
  optional?: boolean;
}) {
  const display = value ?? min;
  const commit = (raw: number) => {
    if (!Number.isFinite(raw)) return;
    const n = Math.min(max, Math.max(min, raw));
    if (n !== value) onChange(n);
  };

  return (
    <div className="scale">
      <div className="scale__head">
        <p className="scale__label" id={`${id}-label`}>
          {label}
          {optional ? <span className="scale__optional"> optional</span> : null}
        </p>
        <span className="scale__value" aria-live="polite">
          {value === null ? "—" : value}
          <span className="scale__max">/10</span>
        </span>
      </div>
      {hint ? <p className="scale__hint">{hint}</p> : null}
      <input
        className="scale__range"
        type="range"
        min={min}
        max={max}
        step={step}
        value={display}
        aria-labelledby={`${id}-label`}
        onPointerDown={() => commit(display)}
        onTouchStart={() => commit(display)}
        onInput={(e) => commit(Number((e.target as HTMLInputElement).value))}
        onChange={(e) => commit(Number(e.target.value))}
      />
      <div className="scale__ticks" aria-hidden="true">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
